module.exports = __webpack_public_path__ + "static/media/027.2fa6f4e2.jpg";